import { useEffect, useState } from 'react';

// Custom hook to load product images (supports both local and remote)
export const useProductImage = (product) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (!product) {
      return;
    }

    // Priority 1: Use product's direct image path (from PillPoint data)
    if (product.image && typeof product.image === 'string') {
      setImageUrl(product.image);
      return;
    }

    // Priority 2: Use imagery array from PillPoint products (primary data structure)
    if (product.imagery && Array.isArray(product.imagery) && product.imagery.length > 0) {
      const firstImage = product.imagery[0];
      const imgPath = firstImage?.localPath || firstImage?.remoteUrl;
      if (imgPath) {
        setImageUrl(imgPath);
        return;
      }
    }

    // Priority 3: Use first image from images array (supports both scraped and pillpoint images)
    if (product.images && Array.isArray(product.images) && product.images.length > 0) {
      const firstImage = product.images[0];
      if (typeof firstImage === 'string') {
        setImageUrl(firstImage);
      } else if (typeof firstImage === 'object') {
        // Handle object format: {src, localPath, remoteUrl, ...}
        // Check localPath first, then src, then remoteUrl
        const imgPath = firstImage?.localPath || firstImage?.src || firstImage?.remoteUrl;
        setImageUrl(imgPath);
      }
      return;
    }

    // Priority 4: Check for _pillpointOriginal nested data
    if (product._pillpointOriginal?.images?.[0]) {
      const imgPath = product._pillpointOriginal.images[0].src || product._pillpointOriginal.images[0].localPath || product._pillpointOriginal.images[0].remoteUrl;
      if (imgPath) {
        setImageUrl(imgPath);
        return;
      }
    }
    
    // Priority 5: Legacy _pillpointOriginal.imagery support
    if (product._pillpointOriginal?.imagery?.[0]) {
      const imgPath = product._pillpointOriginal.imagery[0].localPath || product._pillpointOriginal.imagery[0].remoteUrl;
      if (imgPath) {
        setImageUrl(imgPath);
        return;
      }
    }

    // Fallback: Use placeholder image
    setImageUrl('/images/placeholder.svg');
    
  }, [product]);

  return { imageUrl };
};

export default useProductImage;